import actionTypes from "./actionTypes";

// UTILS
import * as zmluvyUtils from "../utils/zmluvy/zmluvyUtils";
import * as odberatelUtils from "../utils/odberatel/odberatelUtils";
import * as odberneMiestaUtils from "../utils/odberneMiesta/odberneMiestaUtils";

// ACTIONS
import * as odberneMiestaActions from "./odberneMiesta/odberneMiestaActions";
import * as zmluvyActions from "./zmluvy/zmluvyActions";

const _DEFAULTS = {
  SORT: [],
  PAGE: { skip: 0, take: 20 },
};

export const showAppHeader = (show) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.SHOW_APP_HEADER,
      data: show,
    });
  };
};
export const changeHeaderTitle = (title) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_HEADER_TITLE,
      data: title,
    });
  };
};

const getListOMHeaderRequest = () => ({
  type: actionTypes.GET_LIST_OM_HEADER_REQUEST,
});
const getListOMHeaderSuccess = (res) => ({
  type: actionTypes.GET_LIST_OM_HEADER_SUCCESS,
  res,
});
const getListOMHeaderFailure = (error) => ({
  type: actionTypes.GET_LIST_OM_HEADER_FAILURE,
  error,
});
export const getListOMHeader = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getListOMHeaderRequest());
      let res = await odberneMiestaUtils.getListOM(filter, sort, page);
      dispatch(getListOMHeaderSuccess(res));
    } catch (error) {
      dispatch(getListOMHeaderFailure(error));
    }
  };
};
export const getListOMHeaderAndChangeOM = ({ grids, customFilters }) => {
  return async (dispatch) => {
    try {
      const { SORT, PAGE } = _DEFAULTS;
      const filters = [...customFilters];

      // GET LIST OM HEADER
      dispatch(getListOMHeaderRequest());
      let res = await odberneMiestaUtils.getListOM({ filters }, SORT, PAGE);
      let OM = { I_ZIS_OM: null, NAZOV: "Všetky" };

      const { Items } = res.Data;
      if (Items?.length === 1) {
        OM = Items[0];
      } else {
        res.Data.Items = [{ ...OM }, ...Items];
      }
      dispatch(getListOMHeaderSuccess(res));

      // CHANGE OM
      const data = { OM, grids };
      dispatch(odberneMiestaActions.changeOM(data));
    } catch (error) {
      dispatch(getListOMHeaderFailure(error));
    }
  };
};

const getListZmluvaHeaderRequest = () => ({
  type: actionTypes.GET_LIST_ZMLUVA_HEADER_REQUEST,
});
const getListZmluvaHeaderSuccess = (res) => ({
  type: actionTypes.GET_LIST_ZMLUVA_HEADER_SUCCESS,
  res,
});
const getListZmluvaHeaderFailure = (error) => ({
  type: actionTypes.GET_LIST_ZMLUVA_HEADER_FAILURE,
  error,
});
export const getListZmluvaHeader = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      await dispatch(getListZmluvaHeaderRequest());
      let res = await zmluvyUtils.getListZmluva(filter, sort, page);
      await dispatch(getListZmluvaHeaderSuccess(res));
    } catch (error) {
      await dispatch(getListZmluvaHeaderFailure(error));
    }
  };
};
export const getListZmluvaHeaderAndChangeZmluva = ({
  grids,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      const { SORT, PAGE } = _DEFAULTS;
      const filters = [...customFilters];

      // GET LIST ZMLUVA HEADER
      dispatch(getListZmluvaHeaderRequest());
      let res = await zmluvyUtils.getListZmluva({ filters }, SORT, PAGE);
      dispatch(getListZmluvaHeaderSuccess(res));

      // CHANGE ZMLUVA
      let zmluva = { C_ZMLUVY: "", I_ZMLUVY: null };

      const { Items } = res.Data;
      if (Items?.length === 1) {
        zmluva = Items[0];
      }

      const data = { zmluva, grids };
      dispatch(zmluvyActions.changeZmluva(data));
    } catch (error) {
      dispatch(getListZmluvaHeaderFailure(error));
    }
  };
};

const getListOdberatelHeaderRequest = () => ({
  type: actionTypes.GET_LIST_ODBERATEL_HEADER_REQUEST,
});
const getListOdberatelHeaderSuccess = (res) => ({
  type: actionTypes.GET_LIST_ODBERATEL_HEADER_SUCCESS,
  res,
});
const getListOdberatelHeaderFailure = (error) => ({
  type: actionTypes.GET_LIST_ODBERATEL_HEADER_FAILURE,
  error,
});
export const getListOdberatelHeader = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      await dispatch(getListOdberatelHeaderRequest());
      let res = await odberatelUtils.getListOdberatel(filter, sort, page);
      await dispatch(getListOdberatelHeaderSuccess(res));
    } catch (error) {
      await dispatch(getListOdberatelHeaderFailure(error));
    }
  };
};
